$(document).on('click', '.lightbox', function () {
  var src = $(this).data('orig')

  $('body').append('<div class="preview preview-lightbox"><a class="preview-close"><svg width="32px" height="31px" viewBox="0 0 32 31" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.400000006"><g transform="translate(-1245.000000, -53.000000)" fill="#FFFFFF"><g transform="translate(1245.000000, 53.000000)"><rect transform="translate(16.000000, 15.500000) rotate(-45.000000) translate(-16.000000, -15.500000) " x="-3" y="13" width="38" height="5"/><rect transform="translate(16.000000, 15.500000) rotate(45.000000) translate(-16.000000, -15.500000) " x="-3" y="13" width="38" height="5"/></g> </g></g></svg></a><div class="preview-actions"></div><div class="container"></div></div>')

  const $container = $('.preview > .container')
  $container.append('<div class="inner"><img src="' + src + '"/></div>')

  $('.preview-lightbox').click(function () {
    $('.preview').fadeOut(function () {$(this).remove()})
  })
})
